// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_2eUEw","dangerous":"view-default_dangerous_V5hH4"};